import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RevealOverlay } from '@/components/background/RevealOverlay';
import { setting, usePublicContent } from './use-public-content';

/**
 * Full-bleed photograph that breaks up the long run of text between the
 * process timeline and the trust band, and restates the savings claim over it.
 */
export function PhotoBand() {
  const { t } = useTranslation();
  const { settings } = usePublicContent();
  const percent = setting(settings, 'company.savingsPercent', '40');

  return (
    <Box
      component="section"
      aria-label={t('hero.badge', { percent })}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: { xs: 260, sm: 320, md: 380 },
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Box
        component="img"
        src="/images/panels-sky.webp"
        alt=""
        aria-hidden
        loading="lazy"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          // Framed low so the array fills the band rather than empty sky.
          objectPosition: 'center 78%',
        }}
      />
      {/* Scrim: the sky in this photo is bright enough to fail contrast without it. */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(180deg, rgba(11,28,54,.72) 0%, rgba(11,28,54,.84) 100%)',
        }}
      />
      <RevealOverlay radius={280} />

      <Container maxWidth="md" sx={{ position: 'relative', textAlign: 'center' }}>
        <Typography variant="h2" sx={{ color: 'common.white' }}>
          {t('hero.badge', { percent })}
        </Typography>
        <Typography variant="subtitle1" component="p" sx={{ color: 'grey.200', mt: 1.5 }}>
          {t('hero.badgeNote')}
        </Typography>
      </Container>
    </Box>
  );
}
